export const environment = {
  production: false,
  // apiUrl: 'http://localhost:8081',
  apiUrl: 'https://core-admin-dev.matidor.com'
};